import { render } from "./MinhasCompras.vue?vue&type=template&id=1010d890&scoped=true"
import script from "./MinhasCompras.vue?vue&type=script&lang=js"
export * from "./MinhasCompras.vue?vue&type=script&lang=js"

import "./MinhasCompras.vue?vue&type=style&index=0&id=1010d890&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1010d890"]])

export default __exports__